module.exports = __webpack_public_path__ + "static/media/datamining.daab16a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/datamining.jpg
// module id = 382
// module chunks = 0